@if (erRedigerSak()) {
  <sak-rediger [id]="sak().id" (vedLukk)="redigerSakFerdig()" (vedGaaTilRedigerReferat)="redigerReferat()"/>

} @else {
  <div (draOgSlippFil)="filerValgtForOpplasting($event)"
       [draOgSlippStoettet]="draOgSlippFilStoettet()"
       [meldingVedAktivert]="draOgSlippIndikatorFragment"
       [meldingVedIkkeStoettet]="draOgSlippIkkeStoettetIndikatorFragment"></div>
  <ng-template #draOgSlippIndikatorFragment>
    <dra-og-slipp-fil-aktivert-melding>{{ 'Slipp filene for å legge til som saksdokumenter under "{navn}"'|translate: {navn: sak().tittel} }}</dra-og-slipp-fil-aktivert-melding>
  </ng-template>
  <ng-template #draOgSlippIkkeStoettetIndikatorFragment>
    <dra-og-slipp-fil-aktivert-melding ikon="block">{{ 'Nye saksdokumenter kan ikke registreres da møtet er låst for redigering'|translate }}</dra-og-slipp-fil-aktivert-melding>
  </ng-template>

  <div class="tittel-og-detaljer-kontainer">
    <div class="tittel-linje" toggleKlasseVedSticky>
      <span class="nummer" data-testid="saksnummer">
        {{ sak().nummer }}
        @if (erFavoritt()) {
          <mat-icon fontSet="ion-ios-star" class="favoritt mat-icon--ionic-ikon" inline="true"/>
        }
      </span>
      <span class="tittel" data-testid="sakstittel">{{ sak().tittel }}</span>
      <span class="ansvarlig" data-testid="saksansvarlig">
        <avatar [medlem]="sak().ansvarlig" [navn]="sak().sp2Ansvarlig"/>
      </span>
      <span class="handlinger">
        @if (redigeringMulig()) {
          <button mat-icon-button
                  (click)="redigerSak()"
                  [disabled]="menyDeaktivert()"
                  class="rediger-knapp"
                  matTooltip="{{ 'Rediger saksnavn, tidspunkt, tema, beskrivelse etc.' | translate }}"
                  matTooltipPosition="below"
                  data-testid="rediger-sak-knapp">
            <mat-icon>edit</mat-icon>
          </button>
        }
        <button mat-icon-button
                [matMenuTriggerFor]="sakMeny"
                (click)="$event.stopPropagation()"
                [disabled]="menyDeaktivert()"
                class="meny-trigger"
                aria-label="Meny"
                data-testid="saksmeny-knapp">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #sakMeny="matMenu" aria-label="{{'Saksmeny'|translate}}">
          @if (redigeringMulig()) {
            <button mat-menu-item (click)="redigerReferat()">
              <mat-icon>edit</mat-icon>
              {{ 'Rediger referat' | translate }}
            </button>
            <button mat-menu-item (click)="flyttSak()">
              <mat-icon>move_down</mat-icon>
              {{ 'Flytt' | translate }}
            </button>
          }
          @if (kopierMulig()) {
            <button mat-menu-item (click)="kopierSak()">
              <mat-icon>content_copy</mat-icon>
              {{ 'Kopier' | translate }}
            </button>
          }
          @if (redigeringMulig()) {
            <button mat-menu-item (klikk)="slettSak()" [bekreftKlikk]="'Ja, slett saken' | translate" data-testid="slett">
              <mat-icon fontSet="ion-ios-trash" class="mat-icon--ionic-ikon"/>
              {{ 'Slett'|translate }}
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="redigerSkjerming()">
              <mat-icon>visibility_lock</mat-icon>
              {{ 'Rediger tilgang' | translate }}
            </button>
          }
          <button mat-menu-item (click)="endreFavorittmarkering()">
            <mat-icon>star</mat-icon>
            @if (erFavoritt()) {
              {{ 'Fjern fra favorittlisten' | translate }}
            }
            @if (!erFavoritt()) {
              {{ 'Legg til i favorittlisten' | translate }}
            }
          </button>
          <mat-divider></mat-divider>
          @if (redigeringMulig()) {
            <button mat-menu-item (click)="visRegistrerDokumentDialog()">
              <mat-icon fontSet="lederplan-ikon-dokument" class="panel-entitet-ikon mat-icon--lederplan-ikon"/>
              {{ 'Nytt dokument' | translate }}
            </button>
          }
          @if (nyOppgaveMulig()) {
            <button mat-menu-item (click)="nyOppgave()">
              <mat-icon fontSet="lederplan-ikon-oppgave" class="panel-entitet-ikon mat-icon--lederplan-ikon"/>
              {{ 'Ny oppgave' | translate }}
            </button>
            <button mat-menu-item (click)="nyAvstemning()">
              <mat-icon fontSet="lederplan-ikon-avstemning" class="panel-entitet-ikon mat-icon--lederplan-ikon"/>
              {{ 'Ny avstemning' | translate }}
            </button>
            <button mat-menu-item (click)="nyBeslutning()">
              <mat-icon fontSet="lederplan-ikon-beslutning" class="panel-entitet-ikon mat-icon--lederplan-ikon"/>
              @if (moeteStartdatoPassert()) {
                {{ 'Ny beslutning' | translate }}
              }
              @if (!moeteStartdatoPassert()) {
                {{ 'Nytt forslag til beslutning' | translate }}
              }
            </button>
          }
          <button mat-menu-item (click)="nyKommentarTraad()">
            <mat-icon fontSet="ion-ios-chatbubble-outline" class="mat-icon--ionic-ikon"/>
            {{ 'Ny kommentar' | translate }}
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="aapneSaksdokument()">
            <mat-icon fontSet="lederplan-ikon-dokument-pdf" class="panel-entitet-ikon mat-icon--lederplan-ikon"/>
            {{ 'Saksdokument' | translate }}
          </button>
        </mat-menu>
      </span>
    </div>

    <tittel-verdi-samling stil="horisontal" class="detaljer-linje">
      <!--enkeltdagsmøte - viser starttidspunkt med mindre ingen saker har satt varighet-->
      @if (!sakstidspunkt().flerdagsmoete && !sakstidspunkt().ingenVarigheterSatt) {
        <tittel-verdi tittel="{{ 'Starttidspunkt' | translate }}" [verdi]="sakstidspunkt().start | zoneddatetimeSomPlainTime | plaintime" data-testid="sakstidspunkt"/>
      }
      <!--flerdagsmoete - viser dag og starttidspunkt dersom ALLE saker har satt varighet, eller starttidpunkt er satt på saken-->
      @if (sakstidspunkt().flerdagsmoete && (!sakstidspunkt().enkelteVarigheterIkkeSatt || sakstidspunkt().start)) {
        <tittel-verdi tittel="{{ 'Starttidspunkt' | translate }}" data-testid="sakstidspunkt">
          <verdi>
            {{ 'Dag {dag}' | translate: {dag: sakstidspunkt().dag + 1} }},
            {{ sakstidspunkt().start | zoneddatetimeSomPlaindate | plaindate:{weekday: 'short', day: 'numeric'} }}
            {{ sakstidspunkt().start | zoneddatetimeSomPlainTime | plaintime }}
          </verdi>
        </tittel-verdi>
      }
      <!--flerdagsmoete - viser kun dag når IKKE alle saker har satt varighet og det ikke er satt starttidspunkt-->
      @if (sakstidspunkt().flerdagsmoete && sakstidspunkt().enkelteVarigheterIkkeSatt && !sakstidspunkt().start) {
        <tittel-verdi tittel="{{ 'Starttidspunkt' | translate }}" [verdi]="'Dag {{dag}}' | translate: {dag: sakstidspunkt().dag + 1}" data-testid="sakstidspunkt"/>
      }
      <!--enkeltdagsmøte - viser varighet (beregnet eller angitt) med mindre ingen saker har satt varighet-->
      @if (!sakstidspunkt().flerdagsmoete && !sakstidspunkt().ingenVarigheterSatt) {
        <tittel-verdi tittel="{{ 'Varighet' | translate }}" data-testid="saksvarighet">
          <verdi>
            {{ sakstidspunkt().varighet | duration: 'timerMinutterKort' }}
            @if (sakstidspunkt().varighetBeregnet) {
              <span class="std-nedtonet">
                {{ '(beregnet)' | translate }}
                <span [matTooltip]="'Varighet er ikke satt på saken, viser derfor beregnet varighet basert på gjenværende tid' | translate" matTooltipPosition="below"></span>
              </span>
            }
          </verdi>
        </tittel-verdi>
      }

      <!--flerdagsmoete - viser varighet dersom angitt av bruker på sak-->
      @if (sakstidspunkt().flerdagsmoete && sakstidspunkt().varighetAngitt) {
        <tittel-verdi tittel="{{ 'Varighet' | translate }}" [verdi]="sakstidspunkt().varighet | duration: 'timerMinutterKort'" data-testid="saksvarighet"/>
      }
      @if (!sakstidspunkt().varighetAngitt && !sakstidspunkt().varighetBeregnet) {
        <tittel-verdi tittel="{{ 'Varighet ikke satt' | translate }}" data-testid="saksvarighet"/>
      }

      <tittel-verdi tittel="{{ 'Sakstype' | translate }}" data-testid="sakstype">
        <verdi>
          @if (sak().sakstype) {
            <span class="klikkbar e2e-gaatilsakstype" (click)="navigerTilSakstype()">{{ sak().sakstype!.navn }}</span>
          } @else {
            <span>-</span>
          }
        </verdi>
      </tittel-verdi>
      <tittel-verdi tittel="{{ 'Tema' | translate }}" data-testid="tema">
        <verdi>
          @if (sak().tema) {
            <tema-med-beskrivelse [tema]="sak().tema!" (vedKlikk)="navigerTilTema()"/>
          } @else {
            -
          }
        </verdi>
      </tittel-verdi>
    </tittel-verdi-samling>

    <tittel-verdi stil="vertikal--med-linje" class="saksbeskrivelse" data-testid="saksbeskrivelse">
      <tittel>
        {{ 'Saksbeskrivelse' | translate }}
        @if (redigeringMulig()) {
          <button mat-icon-button class="md-icon-button-mindre" (click)="redigerSak()" [disabled]="menyDeaktivert()">
            <mat-icon>edit</mat-icon>
          </button>
        }
      </tittel>
      <verdi>
        <html-formatert [innhold]="sak().beskrivelse"/>
      </verdi>
    </tittel-verdi>
  </div>

  @if ((sak().referat?.length ?? 0) > 0 && !erRedigerReferat()) {
    <tittel-verdi stil="vertikal--med-linje" class="referat">
      <tittel>
        {{ 'Referat' | translate }}
        @if (redigeringMulig()) {
          <button mat-icon-button class="md-icon-button-mindre" (click)="redigerReferat()" [disabled]="menyDeaktivert()">
            <mat-icon>edit</mat-icon>
          </button>
        }
      </tittel>
      <verdi>
        <html-formatert [innhold]="sak().referat" data-testid="sak-referat"/>
      </verdi>
    </tittel-verdi>
  }

  @if (visForslagTilBeslutninger() && !erRedigerReferat()) {
    <tittel-verdi stil="vertikal--med-linje" class="beslutninger">
      <tittel>
        {{ 'Forslag til beslutninger' | translate }}
        @if (redigeringMulig()) {
          <button mat-icon-button class="md-icon-button-mindre" (click)="nyBeslutning()" [disabled]="menyDeaktivert()">
            <mat-icon fontIcon="ion-ios-plus-outline"></mat-icon>
          </button>
        }
      </tittel>
      <verdi>
        <sak-liste-beslutninger [sakId]="sak().id" [visKunForslag]="true"/>
      </verdi>
    </tittel-verdi>
  }

  @if (visEndeligeBeslutninger() && !erRedigerReferat()) {
    <tittel-verdi stil="vertikal--med-linje" class="beslutninger">
      <tittel>
        {{ 'Beslutninger' | translate }}
        @if (redigeringMulig()) {
          <button mat-icon-button class="md-icon-button-mindre" (click)="nyBeslutning()" [disabled]="menyDeaktivert()">
            <mat-icon fontIcon="ion-ios-plus-outline"></mat-icon>
          </button>
        }
      </tittel>
      <verdi>
        <sak-liste-beslutninger [sakId]="sak().id"/>
      </verdi>
    </tittel-verdi>
  }

  @if (erRedigerReferat()) {
    <tittel-verdi stil="vertikal--med-linje" tittel="{{ 'Referat' | translate }}">
      <verdi>
        <sak-rediger-referat [sakId]="sak().id" [moeteId]="sak().moete.id" [gruppeId]="sak().eiendeGruppeId" (vedAvsluttet)="redigerReferatAvsluttet($event)"/>
      </verdi>
    </tittel-verdi>
  }

  @if (visDokumenter()) {
    <tittel-verdi stil="vertikal--med-linje" class="dokumenter">
      <tittel>
        {{ 'Dokumenter' | translate }}
        @if (redigeringMulig()) {
          <button mat-icon-button class="md-icon-button-mindre" (click)="visRegistrerDokumentDialog()" [disabled]="menyDeaktivert()">
            <mat-icon fontIcon="ion-ios-plus-outline"></mat-icon>
          </button>
        }
        <mat-button-toggle-group [formControl]="dokumenterVisningsmodusKontroll" hideSingleSelectionIndicator="true" class="dokument-visningsmodusvelger" aria-label="Visningsmodus">
          <mat-button-toggle value="liste" matTooltip="{{ 'Vis dokumenter som liste' | translate }}" data-testid="listevisning">
            <mat-icon>list</mat-icon>
          </mat-button-toggle>
          <mat-button-toggle value="kort" matTooltip="{{ 'Vis dokumenter som kort' | translate }}" data-testid="kortvisning">
            <mat-icon>grid_on</mat-icon>
          </mat-button-toggle>
        </mat-button-toggle-group>
      </tittel>
      <verdi>
        <sak-liste-dokumenter [sakId]="sak().id" [eiendeGruppeId]="sak().eiendeGruppeId" [visning]="dokumenterVisningsmodusKontroll.value"/>
      </verdi>
    </tittel-verdi>
  }

  @if (visOppgaver()) {
    <tittel-verdi stil="vertikal--med-linje" data-testid="oppgaver">
      <tittel>
        {{ 'Oppgaver' | translate }}
        @if (redigeringMulig()) {
          <button mat-icon-button class="md-icon-button-mindre" (click)="nyOppgave()" [disabled]="menyDeaktivert()">
            <mat-icon fontIcon="ion-ios-plus-outline"></mat-icon>
          </button>
        }
      </tittel>
      <verdi>
        <sak-liste-oppgaver [sakId]="sak().id"/>
      </verdi>
    </tittel-verdi>
  }

  @if (visAvstemninger()) {
    <tittel-verdi stil="vertikal--med-linje" data-testid="avstemninger">
      <tittel>
        {{ 'Avstemninger' | translate }}
        @if (redigeringMulig()) {
          <button mat-icon-button class="md-icon-button-mindre" (click)="nyAvstemning()" [disabled]="menyDeaktivert()">
            <mat-icon fontIcon="ion-ios-plus-outline"></mat-icon>
          </button>
        }
      </tittel>
      <verdi>
        <sak-liste-avstemninger [sakId]="sak().id" [moeteId]=sak().moete.id [moeteLaastForRedigering]="sak().moete.laastForRedigering"/>
      </verdi>
    </tittel-verdi>
  }

  @if (visKommentarer() || tvingVisKommentarer()) {
    <tittel-verdi stil="vertikal--med-linje" tittel="{{ 'Kommentarer' | translate }}" data-testid="kommentarer" class="ikke-print">
      <verdi>
        <sak-kommentarer [sakId]="sak().id" [gruppeId]="sak().eiendeGruppeId"/>
      </verdi>
    </tittel-verdi>
  }

  <fab-meny toggleKlasseVedSticky [class.er-deaktivert]="menyDeaktivert()">
      @if (redigeringMulig()) {
        <button mat-mini-fab color="secondary" (click)="visRegistrerDokumentDialog()" [disabled]="menyDeaktivert()" [matTooltip]="'Nytt dokument' | translate" matTooltipPosition="above">
          <mat-icon fontSet="lederplan-ikon-dokument" class="panel-entitet-ikon mat-icon--lederplan-ikon"/>
        </button>
      }
      @if (nyOppgaveMulig()) {
        <button mat-mini-fab color="secondary" (click)="nyOppgave()" [disabled]="menyDeaktivert()" [matTooltip]="'Ny oppgave' | translate" matTooltipPosition="above">
          <mat-icon fontSet="lederplan-ikon-oppgave" class="panel-entitet-ikon mat-icon--lederplan-ikon"/>
        </button>
      }
      @if (redigeringMulig()) {
        <button mat-mini-fab color="secondary" (click)="nyAvstemning()" [disabled]="menyDeaktivert()" [matTooltip]="'Ny avstemning' | translate" matTooltipPosition="above">
          <mat-icon fontSet="lederplan-ikon-avstemning" class="panel-entitet-ikon mat-icon--lederplan-ikon"/>
        </button>
        <button mat-mini-fab color="secondary" (click)="nyBeslutning()" [disabled]="menyDeaktivert()" [matTooltip]="'Ny beslutning' | translate" matTooltipPosition="above">
          <mat-icon fontSet="lederplan-ikon-beslutning" class="panel-entitet-ikon mat-icon--lederplan-ikon"/>
        </button>
      }
      <button mat-mini-fab color="secondary" (click)="nyKommentarTraad()" [disabled]="menyDeaktivert()" [matTooltip]="'Ny kommentar' | translate" matTooltipPosition="above">
        <mat-icon fontSet="ion-ios-chatbubble-outline" class="mat-icon--ionic-ikon"/>
      </button>
    </fab-meny>

}
